module.exports = __webpack_public_path__ + "img/3.a570bfe4.png";